import './src/styles/index.scss'

import Page from './src/components/wrap/page'
import Root from './src/components/wrap/root'

export const wrapPageElement = Page
export const wrapRootElement = Root
